import { render, staticRenderFns } from "./edit-pile.vue?vue&type=template&id=045d238d&"
import script from "./edit-pile.vue?vue&type=script&lang=ts&"
export * from "./edit-pile.vue?vue&type=script&lang=ts&"
import style0 from "./edit-pile.vue?vue&type=style&index=0&id=045d238d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports